import {
  ADD_QUIZ_FAILURE,
  ADD_QUIZ_REQUEST,
  ADD_QUIZ_SUCCESS,
  CLEAR_QUIZ_ERRORS,
  DELETE_QUIZ_FAILURE,
  DELETE_QUIZ_REQUEST,
  DELETE_QUIZ_SUCCESS,
  DELETE_ALL_QUIZZES_FROM_CHAPTER_REQUEST,
  DELETE_ALL_QUIZZES_FROM_CHAPTER_SUCCESS,
  DELETE_ALL_QUIZZES_FROM_CHAPTER_FAILURE,
  UPSERT_QUIZZES_FOR_CHAPTER_REQUEST,
  UPSERT_QUIZZES_FOR_CHAPTER_SUCCESS,
  UPSERT_QUIZZES_FOR_CHAPTER_FAILURE,
  GET_QUIZZES_BY_CHAPTER_REQUEST,
  GET_QUIZZES_BY_CHAPTER_SUCCESS,
  GET_QUIZZES_BY_CHAPTER_FAILURE,
  GET_QUIZZES_BY_CHAPTER_ID_FAILURE,
  GET_QUIZZES_BY_CHAPTER_ID_REQUEST,
  GET_QUIZZES_BY_CHAPTER_ID_SUCCESS,
} from "./ActionType";

const initialState = {
  quizListResponse: {},
  deleteQuizResult: {},
  addQuizResult: {},
  deleteAllQuizzesFromChapterResult: {},
  upsertQuizzesForChapterResult: {},
  quizzesByChapter: [],

  loadingAdd: false,
  loadingDelete: false,
  loadingFetch: false,
  loadingDeleteAllQuizzes: false,
  loadingUpsertQuizzes: false,
  loadingQuizzesByChapter: false,

  errorAdd: null,
  errorDelete: null,
  errorFetch: null,
  errorDeleteAllQuizzes: null,
  errorUpsertQuizzes: null,
  errorQuizzesByChapter: null,
};

export const quizReducer = (state = initialState, action) => {
  switch (action.type) {
    // === ADD QUIZ ===
    case ADD_QUIZ_REQUEST:
      return {
        ...state,
        loadingAdd: true,
        errorAdd: null,
      };
    case ADD_QUIZ_SUCCESS:
      return {
        ...state,
        loadingAdd: false,
        addQuizResult: action.payload,
      };
    case ADD_QUIZ_FAILURE:
      return {
        ...state,
        loadingAdd: false,
        errorAdd: action.payload,
      };

    // === GET QUIZZES ===
    case GET_QUIZZES_BY_CHAPTER_ID_REQUEST:
      return {
        ...state,
        loadingFetch: true,
        errorFetch: null,
      };
    case GET_QUIZZES_BY_CHAPTER_ID_SUCCESS:
      return {
        ...state,
        loadingFetch: false,
        quizListResponse: action.payload,
      };
    case GET_QUIZZES_BY_CHAPTER_ID_FAILURE:
      return {
        ...state,
        loadingFetch: false,
        errorFetch: action.payload,
      };

    // === DELETE QUIZ ===
    case DELETE_QUIZ_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        errorDelete: null,
      };
    case DELETE_QUIZ_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        deleteQuizResult: action.payload,
      };
    case DELETE_QUIZ_FAILURE:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: action.payload,
      };
    // === DELETE ALL QUIZZES FROM CHAPTER ===
    case DELETE_ALL_QUIZZES_FROM_CHAPTER_REQUEST:
      return {
        ...state,
        loadingDeleteAllQuizzes: true,
        errorDeleteAllQuizzes: null,
      };
    case DELETE_ALL_QUIZZES_FROM_CHAPTER_SUCCESS:
      return {
        ...state,
        loadingDeleteAllQuizzes: false,
        errorDeleteAllQuizzes: null,
        deleteAllQuizzesFromChapterResult: action.payload,
      };
    case DELETE_ALL_QUIZZES_FROM_CHAPTER_FAILURE:
      return {
        ...state,
        loadingDeleteAllQuizzes: false,
        errorDeleteAllQuizzes: action.payload,
      };

    // === UPSERT QUIZZES FOR CHAPTER ===
    case UPSERT_QUIZZES_FOR_CHAPTER_REQUEST:
      return {
        ...state,
        loadingUpsertQuizzes: true,
        errorUpsertQuizzes: null,
      };
    case UPSERT_QUIZZES_FOR_CHAPTER_SUCCESS:
      return {
        ...state,
        loadingUpsertQuizzes: false,
        errorUpsertQuizzes: null,
        upsertQuizzesForChapterResult: action.payload,
      };
    case UPSERT_QUIZZES_FOR_CHAPTER_FAILURE:
      return {
        ...state,
        loadingUpsertQuizzes: false,
        errorUpsertQuizzes: action.payload,
      };

    // === GET QUIZZES BY CHAPTER ===
    case GET_QUIZZES_BY_CHAPTER_REQUEST:
      console.log("Reducer: GET_QUIZZES_BY_CHAPTER_REQUEST");
      return {
        ...state,
        loadingQuizzesByChapter: true,
        errorQuizzesByChapter: null,
      };
    case GET_QUIZZES_BY_CHAPTER_SUCCESS:
      console.log("Reducer: GET_QUIZZES_BY_CHAPTER_SUCCESS with payload:", action.payload);
      return {
        ...state,
        loadingQuizzesByChapter: false,
        errorQuizzesByChapter: null,
        quizzesByChapter: action.payload,
      };
    case GET_QUIZZES_BY_CHAPTER_FAILURE:
      console.log("Reducer: GET_QUIZZES_BY_CHAPTER_FAILURE with payload:", action.payload);
      return {
        ...state,
        loadingQuizzesByChapter: false,
        errorQuizzesByChapter: action.payload,
      };

    case CLEAR_QUIZ_ERRORS:
      return {
        ...state,
        errorAdd: null,
        errorDelete: null,
        errorFetch: null,
        errorDeleteAllQuizzes: null,
        errorUpsertQuizzes: null,
        errorQuizzesByChapter: null,
      };

    default:
      return state;
  }
};
